/* Toolsmith a11y shims for Horizon-native issues (audit 2026-06-29). Additive + idempotent; no visual change. */
(function () {
  function applyFixes() {
    try {
      // 1. Slideshow dots: aria-selected is invalid on role=button. Expose pure-dots groups as tabs (keeps
      //    aria-selected valid for Horizon's CSS; only when the container is exclusively dot buttons).
      document.querySelectorAll('button[aria-selected]').forEach(function (b) {
        var list = b.closest('ul, ol');
        if (!list) return; // only handle list-based slideshow dot patterns
        if (b.getAttribute('role') !== 'tab') b.setAttribute('role', 'tab');
        var li = b.parentElement; // make the li transparent so the list isn't "non-li" and the tablist is the ul/ol
        if (li && li.tagName === 'LI' && li.getAttribute('role') !== 'presentation') li.setAttribute('role', 'presentation');
        if (list.getAttribute('role') !== 'tablist') list.setAttribute('role', 'tablist');
      });
      // 2. Product-recommendations skeletons are decorative placeholders carrying prohibited ARIA → hide from the a11y tree.
      document.querySelectorAll('.product-recommendations__skeleton-item').forEach(function (e) {
        if (e.getAttribute('aria-hidden') !== 'true') e.setAttribute('aria-hidden', 'true');
      });
      // 3. Scrollable slideshow regions must be keyboard-focusable. Target the real overflow scroller(s); processed once.
      //    2026-10-12: skip single-slide slideshows (e.g. one-image product cards): nothing scrolls, so the
      //    old fallback only added a dead tab stop per card ("use arrow keys" did nothing) and paid a
      //    getComputedStyle() on every descendant. Multi-slide behaviour is unchanged.
      document.querySelectorAll('slideshow-component').forEach(function (s) {
        if (s.getAttribute('data-ts-a11y') === '1') return;
        if (s.querySelectorAll('slideshow-slide').length < 2) { s.setAttribute('data-ts-a11y', '1'); return; }
        var scrollers = [];
        var so = getComputedStyle(s);
        if (/(auto|scroll)/.test(so.overflowX + so.overflowY)) scrollers.push(s);
        s.querySelectorAll('*').forEach(function (el) { var o = getComputedStyle(el); if (/(auto|scroll)/.test(o.overflowX + o.overflowY) && el.scrollWidth > el.clientWidth + 4) scrollers.push(el); });
        if (scrollers.length === 0) scrollers.push(s);
        scrollers.forEach(function (el) { if (!el.hasAttribute('tabindex')) { el.setAttribute('tabindex', '0'); if (!el.hasAttribute('aria-label') && !el.hasAttribute('aria-labelledby')) el.setAttribute('aria-label', 'Slides — use arrow keys to scroll'); } });
        s.setAttribute('data-ts-a11y', '1');
      });
      // 4. Rating divs use a generic role but carry an aria-label → expose as role=img so the label is permitted.
      document.querySelectorAll('.rating[aria-label]:not([role])').forEach(function (e) { e.setAttribute('role', 'img'); });
    } catch (e) { /* never break the page */ }
  }
  var scheduled = false;
  function schedule() { if (scheduled) return; scheduled = true; (window.requestAnimationFrame || window.setTimeout)(function () { scheduled = false; applyFixes(); }, 0); }
  if (document.readyState !== 'loading') applyFixes(); else document.addEventListener('DOMContentLoaded', applyFixes);
  if ('MutationObserver' in window) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-selected'] });
  }
})();
